import React from 'react';
import PropTypes from 'prop-types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { wrapper } from '@store/store';

import DeliveryConditions from '@routes/DeliveryConditions';

import { fetchCMSComponentsData } from '@utils/fetchCMSComponentsData';
import { validateRedirectsByResolvedUrl } from '@utils/redirects';
import { getRequestInstance } from '@utils/request';

import { deliveryConditionsPage } from '@common/endpoints';

const DeliveryConditionsPage = ({ pageData }) => (
  <DeliveryConditions pageData={pageData} />
);

export const getServerSideProps = wrapper.getServerSideProps(
  store => async context => {
    const { locale, resolvedUrl } = context;
    const request = getRequestInstance(context);
    let pageData;

    try {
      const { data } = await request.get(deliveryConditionsPage());

      await fetchCMSComponentsData(store.dispatch, data);
      pageData = data;
    } catch (e) {
      const validatedRedirects = validateRedirectsByResolvedUrl(resolvedUrl);

      if (validatedRedirects) {
        return {
          redirect: validatedRedirects,
        };
      }

      return {
        notFound: true,
      };
    }

    return {
      props: {
        ...(await serverSideTranslations(locale)),
        pageData,
      },
    };
  },
);

DeliveryConditionsPage.propTypes = {
  pageData: PropTypes.shape({
    body: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default DeliveryConditionsPage;
